import useSWR from "swr";
import fetcher from "./fetcher";

const defaultNotices = [];

export default function useSiteNoticeAdmin() {
  const { data, isLoading, error, mutate } = useSWR(
    "/api/siteNotice/admin",
    fetcher,
  );

  return {
    notices: data?.notices ?? defaultNotices,
    isLoading,
    isError: Boolean(error),
    error,
    mutate,
  };
}
